'use client';
import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useTranslatedMessages } from '../../hooks/useTranslatedMessages';

const GoodsOrServiceTypeSelect = ({ name, label, control, error = false, helperText = '', readOnly = false }) => {
  const { eInvoiceForm } = useTranslatedMessages();
  const goodsOrServiceTypeCodesList = useSelector((state) => state.codeLists?.goodsOrServiceTypeCodesList) ?? [];
  const translatedLabel = label ?? eInvoiceForm?.line_item_form?.goods_or_service_type_label ?? 'Goods or Service Type';

  const getSelectedOption = (code) => {
    return goodsOrServiceTypeCodesList.find((item) => item.code === code) || null;
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Autocomplete
          id="goods-or-service-type-select"
          options={goodsOrServiceTypeCodesList}
          readOnly={readOnly}
          getOptionLabel={(option) => `${option.code} - ${option.name}`}
          isOptionEqualToValue={(option, value) => option.code === value?.code}
          value={getSelectedOption(field.value)}
          onChange={(_, selected) => {
            field.onChange(selected?.code ?? '');
          }}
          renderInput={(params) => (
            <TextField {...params} label={translatedLabel} error={error} helperText={helperText} />
          )}
        />
      )}
    />
  );
};

export default GoodsOrServiceTypeSelect;
